export default {
  title: '泛函科技'
}



// WEBPACK FOOTER //
// ./src/lang/zh/footer.js